import type { LucideIcon } from "lucide-react"
import {
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  Badge,
  BadgeCheck,
  Ban,
  Banknote,
  BarChart2,
  BarChart3,
  Bell,
  BellOff,
  BellRing,
  Bug,
  Building2,
  Cake,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  CalendarSync,
  CalendarX,
  Camera,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CookingPot,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleDollarSign,
  CircleHelp,
  CirclePlay,
  CircleStop,
  ClipboardCheck,
  Clock,
  Compass,
  Contact,
  Cookie,
  Copy,
  createLucideIcon,
  CreditCard,
  Crown,
  Database,
  DoorOpen,
  Download,
  Dumbbell,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  FileText,
  Flag,
  FilterX,
  FlaskConical,
  Gamepad2,
  GitBranch,
  Globe,
  Goal,
  GraduationCap,
  GripVertical,
  Hand,
  HardDrive,
  Headset,
  Heart,
  History,
  Home,
  Hourglass,
  Image,
  ImageOff,
  ImagePlus,
  Images,
  Info,
  Landmark,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  Link,
  List,
  ListChecks,
  Loader2,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  MapPinCheck,
  Maximize,
  Maximize2,
  Medal,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Minimize2,
  Minus,
  Monitor,
  Navigation,
  Network,
  NotebookPen,
  Package,
  Paperclip,
  PartyPopper,
  Pencil,
  PersonStanding,
  PiggyBank,
  Play,
  Plus,
  PlusCircle,
  QrCode,
  ReceiptText,
  RefreshCw,
  Rocket,
  RotateCcw,
  Save,
  Scale,
  ScanLine,
  Search,
  SearchX,
  Settings,
  Share2,
  Shield,
  ShieldCheck,
  ShieldUser,
  Shuffle,
  Signal,
  SlidersHorizontal,
  Smartphone,
  Star,
  Stars,
  Store,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Timer,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Undo2,
  Unlink,
  Upload,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  UserRound,
  UserX,
  Users,
  Video,
  VideoOff,
  Volleyball,
  Wallet,
  X,
  XCircle,
} from "lucide-react"

/** Raquete — Lucide Lab `tennis-racket` (não está no pacote core). */
const TennisRacket = createLucideIcon("TennisRacket", [
  [
    "path",
    {
      d: "M10.7 4.7c3-3 7.4-3.6 9.8-1.2s1.8 6.8-1.2 9.8a9.5 9.5 0 0 1-4.3 2.5c-2.1.5-4.1.1-5.5-1.3S7.7 11.1 8.2 9a9.5 9.5 0 0 1 2.5-4.3",
      key: "head",
    },
  ],
  ["path", { d: "M8.2 9 6 18l9-2.2", key: "throat" }],
  ["path", { d: "m2 22 4-4", key: "handle" }],
  ["circle", { cx: "20", cy: "20", r: "2", key: "ball" }],
])

/** Placar — Lucide não tem scoreboard; ícone alinhado ao traço Lucide. */
const Scoreboard = createLucideIcon("Scoreboard", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "frame" }],
  ["path", { d: "M12 5v14", key: "divider" }],
  ["path", { d: "M6 3v2", key: "leg-l" }],
  ["path", { d: "M18 3v2", key: "leg-r" }],
  ["path", { d: "M6 10h3a1.5 1.5 0 0 1 0 3H7.5H9a1.5 1.5 0 0 1 0 3H6", key: "score-l" }],
  ["path", { d: "M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0-3 0", key: "score-r" }],
])

/** Material Symbols name → Lucide component (migration registry). */
export const iconRegistry = {
  account_balance: Landmark,
  account_balance_wallet: Wallet,
  add: Plus,
  add_card: CreditCard,
  add_circle: PlusCircle,
  add_photo_alternate: ImagePlus,
  admin_panel_settings: ShieldUser,
  android: Smartphone,
  arrow_back: ArrowLeft,
  arrow_forward: ArrowRight,
  arrow_forward_ios: ChevronRight,
  attach_file: Paperclip,
  attach_money: Banknote,
  badge: Badge,
  balance: Scale,
  block: Ban,
  bug_report: Bug,
  cake: Cake,
  calendar_month: Calendar,
  calendar_today: CalendarDays,
  camera_alt: Camera,
  cancel: XCircle,
  celebration: PartyPopper,
  chat: MessageCircle,
  chat_bubble: MessageSquare,
  check: Check,
  check_circle: CheckCircle,
  checklist: ListChecks,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  close: X,
  close_fullscreen: Minimize2,
  collections: Layers,
  computer: Monitor,
  confirmation_number: Ticket,
  contacts: Contact,
  content_copy: Copy,
  cookie: Cookie,
  credit_card: CreditCard,
  credit_card_off: Ban,
  credit_score: BadgeCheck,
  dashboard: LayoutDashboard,
  database: Database,
  date_range: CalendarRange,
  delete: Trash2,
  delete_forever: Trash2,
  description: FileText,
  directions: Map,
  directions_run: PersonStanding,
  done_all: CheckCheck,
  door_open: DoorOpen,
  download: Download,
  drag_indicator: GripVertical,
  edit: Pencil,
  edit_note: NotebookPen,
  emoji_events: Trophy,
  error: CircleAlert,
  event: CalendarDays,
  event_available: CalendarCheck,
  event_busy: CalendarX,
  event_repeat: CalendarSync,
  event_upcoming: CalendarClock,
  expand_more: ChevronDown,
  explore: Compass,
  fact_check: ClipboardCheck,
  favorite: Heart,
  file_download: Download,
  filter_alt_off: FilterX,
  flag: Flag,
  fit_screen: Maximize,
  format_list_bulleted: List,
  forum: MessagesSquare,
  grid_view: LayoutGrid,
  group: Users,
  group_add: UserPlus,
  group_off: UserX,
  group_work: Users,
  groups: Users,
  help: CircleHelp,
  hide_image: ImageOff,
  history: History,
  home: Home,
  hotel_class: Star,
  hourglass_empty: Hourglass,
  hourglass_top: Hourglass,
  how_to_reg: UserCheck,
  hub: Network,
  image: Image,
  info: Info,
  insights: TrendingUp,
  install_mobile: Smartphone,
  inventory_2: Package,
  label: Tag,
  leaderboard: BarChart3,
  link: Link,
  link_off: Unlink,
  list: List,
  list_alt: List,
  location_on: MapPin,
  lock: Lock,
  lock_open: LockOpen,
  login: LogIn,
  logout: LogOut,
  mail: Mail,
  map: Map,
  message: MessageSquare,
  mobile_friendly: Smartphone,
  money_off: Ban,
  more_horiz: Ellipsis,
  more_vert: EllipsisVertical,
  navigation: Navigation,
  notifications: Bell,
  notifications_active: BellRing,
  notifications_none: Bell,
  notifications_off: BellOff,
  open_in_full: Maximize2,
  open_in_new: ExternalLink,
  paid: CircleDollarSign,
  payments: CreditCard,
  pending: Clock,
  pending_actions: Clock,
  people: Users,
  person: User,
  person_add: UserPlus,
  person_off: UserX,
  person_outline: UserRound,
  person_pin: MapPin,
  person_remove: UserMinus,
  phone_iphone: Smartphone,
  photo: Image,
  photo_camera: Camera,
  photo_library: Images,
  picture_as_pdf: FileText,
  play_arrow: Play,
  play_circle: CirclePlay,
  policy: FileText,
  progress_activity: Loader2,
  public: Globe,
  qr_code: QrCode,
  qr_code_2: QrCode,
  qr_code_scanner: ScanLine,
  query_stats: BarChart2,
  receipt: ReceiptText,
  receipt_long: ReceiptText,
  refresh: RefreshCw,
  remove: Minus,
  replay: RotateCcw,
  restart_alt: RotateCcw,
  reviews: MessageSquare,
  rocket_launch: Rocket,
  savings: PiggyBank,
  schedule: Clock,
  school: GraduationCap,
  science: FlaskConical,
  scoreboard: Scoreboard,
  search: Search,
  search_off: SearchX,
  security: Shield,
  settings: Settings,
  share: Share2,
  shield_person: ShieldUser,
  shuffle: Shuffle,
  signal_cellular_alt: Signal,
  skillet: CookingPot,
  sports: Dumbbell,
  sports_esports: Gamepad2,
  sports_handball: Hand,
  sports_score: Medal,
  sports_soccer: Goal,
  sports_tennis: TennisRacket,
  sports_volleyball: Volleyball,
  stadium: Building2,
  star: Star,
  star_rate: Star,
  stars: Stars,
  stop_circle: CircleStop,
  storage: HardDrive,
  storefront: Store,
  support_agent: Headset,
  swap_horiz: ArrowLeftRight,
  sync: RefreshCw,
  sync_saved_locally: Save,
  system_update: Download,
  task_alt: CheckCircle2,
  thumb_down: ThumbsDown,
  thumb_up: ThumbsUp,
  timeline: GitBranch,
  timer: Timer,
  today: CalendarCheck,
  trending_up: TrendingUp,
  tune: SlidersHorizontal,
  undo: Undo2,
  upload: Upload,
  verified: BadgeCheck,
  verified_user: ShieldCheck,
  videocam: Video,
  videocam_off: VideoOff,
  visibility: Eye,
  wallpaper: Image,
  warning: TriangleAlert,
  wc: Users,
  where_to_vote: MapPinCheck,
  workspace_premium: Crown,
} as const satisfies Record<string, LucideIcon>

export type IconName = keyof typeof iconRegistry
